
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Der Schweizer Wald steht zunehmend unter Stress`}</h1>
    <h2>{`Wegen Hitze und Trockenheit nehmen Schäden an den Bäumen zu – und die Extremjahre häufen sich.`}</h2>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;